import { Select, type SelectOption } from '@shinetools/lumen-react'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FEC_JOURNAL_TYPES, FecJournalType } from '../../../../../../enums/fecJournalType'

const TYPE_TRANSLATION_KEYS: Record<FecJournalType, string> = {
  [FecJournalType.Purchase]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.purchase',
  [FecJournalType.Sales]: 'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.sales',
  [FecJournalType.Bank]: 'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.bank',
  [FecJournalType.Cash]: 'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.cash',
  [FecJournalType.Payroll]: 'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.payroll',
  [FecJournalType.Od]: 'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.od',
  [FecJournalType.Other]: 'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.other',
  [FecJournalType.Opening]: 'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.type.opening',
}

interface JournalTypeSelectProps {
  disabled: boolean
  onSelect: (type: FecJournalType) => void
  selectedType: FecJournalType
}

export const JournalTypeSelect = ({ disabled, onSelect, selectedType }: JournalTypeSelectProps): ReactElement => {
  const { t } = useTranslation()

  const options: SelectOption[] = useMemo(
    () =>
      FEC_JOURNAL_TYPES.map((type) => ({
        label: t(TYPE_TRANSLATION_KEYS[type]),
        value: type,
      })),
    [t],
  )

  return (
    <Select
      aria-label={t('settings.organization.accounting.fec_file_import.modal.mapping_step.journals.columns.type')}
      disabled={disabled}
      onChange={(value) => onSelect(value as FecJournalType)}
      options={options}
      value={selectedType}
    />
  )
}
